<div class="form-check">
  <input
    type="radio"
    [id]="'rd_'+id"
    [name]="name"
    [value]="selectValue"
    [ngModel]="value"
    (change)="writeValue(selectValue)"
    #inputRef
    class="form-check-input">
  <label class="form-check-label" [for]="'rd_'+id">
    {{ label }}
  </label>
</div>
